var loader = require('./dist/eventExchangeModule');

module.exports = loader;